import React, { useContext } from 'react';

import { app, media } from 'context';
import { Layout, Link, Text } from 'ds';
import { OFFICE_REQUEST_PATH } from 'routes';
import { actions } from 'store/ServicesRequest';
import { selectServicesRequestAddress } from 'store/ServicesRequest/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import ServicesRequestLocationInput from './ServicesRequestLocationInput';
import StepContainer from './StepContainer';
import StepTitle from './StepTitle';
import { generateServicesRequestStepPath } from './utils';

interface Props {}

const ServicesRequestLocation: React.FC<Props> = () => {
  const address = useAppSelector(selectServicesRequestAddress);
  const dispatch = useAppDispatch();
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;
  const { isSmallPhone } = useContext(app);
  return (
    <StepContainer
      step="location"
      nextHref={generateServicesRequestStepPath({ step: 'size' })}
      backHref={generateServicesRequestStepPath({ step: 'services' })}
      ctaDisabled={!address}
      textLayoutProps={isSmallPhone ? { marginTop: 24 } : undefined}
      stepCompletedEventValue={address}
      stepName="location"
    >
      <Layout>
        <StepTitle>Where’s your office?</StepTitle>
      </Layout>
      <>
        <ServicesRequestLocationInput
          onSelect={address => {
            dispatch(actions.setAddress(address));
          }}
          address={address}
          placeholder="Enter building address"
        />
        {!isMobile && (
          <Layout marginTop={48}>
            <Text size="body-sm">
              Still looking for an office?{' '}
              <Link href={`${OFFICE_REQUEST_PATH}`} size="body-sm" semibold={false}>
                We can help
              </Link>
            </Text>
          </Layout>
        )}
      </>
    </StepContainer>
  );
};

export default ServicesRequestLocation;
